module.exports = __webpack_public_path__ + "static/img/item_back_bg_black.a88a39ab.svg";